import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var UsuarioRestService = /** @class */ (function () {
    function UsuarioRestService(httpClient) {
        this.httpClient = httpClient;
    }
    UsuarioRestService.prototype.obtenerDatosUsuarioIdentificado = function () {
        return this.httpClient.get(environment.apiURL + "v1/usuarios/actual");
    };
    UsuarioRestService.prototype.comprobarSiUsuarioIdentificadoEsSolicitante = function () {
        this.httpClient.post(environment.apiURL + "v1/tramites/guardar", {});
        return this.httpClient.get(environment.apiURL + "v1/usuarios/actual/estado/solicitante");
    };
    UsuarioRestService.ngInjectableDef = i0.defineInjectable({ factory: function UsuarioRestService_Factory() { return new UsuarioRestService(i0.inject(i1.HttpClient)); }, token: UsuarioRestService, providedIn: "root" });
    return UsuarioRestService;
}());
export { UsuarioRestService };
